import { InputAdornment, makeStyles, TextField } from '@material-ui/core';
import { ReactComponent as SearchIcon } from 'assets/svg/search.svg';
import { StyledSelectOption } from 'component/StandardDropDownCheckBox';
import themes from 'constants/themes';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IFilterItem, setPurposeFilter } from 'redux/filter/filterSlice';
import { useAppDispatch } from 'redux/store';
import { PATH } from 'routes/constant';
import utils from 'utils/utils';

const PurposeSuggestionWidget = ({ setTriggerUpdateSearch, listOptions }) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const [searchTerm, setSearchTerm] = useState('');

    const handleChangeCategoryFilter = (item: IFilterItem<string>) => {
        history.push(PATH.SEARCH_STYLES, { title: item.title });
        dispatch(setPurposeFilter(item));
    };

    const onSearchPurposeOption = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
    };

    return (
        <div className={classes.sortWrap}>
            <TextField
                className={classes.input}
                placeholder={'Search By Purpose'}
                onChange={onSearchPurposeOption}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                defaultValue={searchTerm}
            />
            {listOptions.filter((item) => item.title.toLowerCase().includes(searchTerm.toLowerCase())).length > 0 ? (
                listOptions
                    .filter((item) => item.title.toLowerCase().includes(searchTerm.toLowerCase()))
                    .map((item: IFilterItem<string>) => (
                        <StyledSelectOption
                            hideAction
                            key={item.value}
                            label={utils.capitalizeString(item.title)}
                            value={item.value}
                            isActive={item.isActive || false}
                            handleChange={() => handleChangeCategoryFilter(item)}
                            style={{ padding: '5px 0' }}
                        />
                    ))
            ) : (
                <div
                    style={{
                        height: '100%',
                        padding: '30px 24px 0',
                        color: '#000',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <h5 className={classes.h5Text}>No Matching Purposes</h5>
                    <p className={classes.pText}>
                        Sorry we don't have any ready purposes matching your requirements. Please try with another
                        purpose.
                    </p>
                </div>
            )}
        </div>
    );
};

export default PurposeSuggestionWidget;

const useStyles = makeStyles(() => ({
    sortWrap: {
        marginTop: 20,
    },
    filterTitle: {
        marginTop: 24,
        fontSize: 18,
        fontWeight: 600,
        color: themes.palette.primary.main,
    },
    selectedItem: {
        background: '#E8F0F1',
    },
    input: {
        width: '100%',
        marginBottom: '16px',
        '& .MuiInputBase-root': {
            padding: '6px 0',
        },
        '& .MuiInput-underline': {
            '&.Mui-focused': {
                bottom: 0,
                borderBottom: 'none',
            },
            '&:before': {
                borderBottom: '1px solid #BBC8CA',
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
        '&.Mui-focused::before': {
            borderBottom: '1px solid #BBC8CA',
        },
        '& input.MuiInputBase-input': {
            fontFamily: 'PoppinsRegular',
            fontSize: 16,
            fontWeight: 400,
            '&::placeholder': {
                color: themes.palette.primary.main,
            },
        },
    },
    h5Text: {
        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '28px',
        lineHeight: '36px',
        textAlign: 'center',
        color: themes.palette.primary.main,
        flex: 'none',
        margin: '10px 0px',
    },
    pText: {
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '24px',
        textAlign: 'center',
        color: themes.palette.primary.main,
        flex: 'none',
        margin: '10px 0 20px 0',
    },
}));
